<template>
  <div style="background-color: #efeeee !important" class="pageContainer">
    <v-container style="max-width: 900px !important">
      <div
        class="d-flex justify-center align-center mb-5 overallformcard"
        v-if="step1"
      >
        <h2 class="formtitle mb-5">Calculate Shipping Rates</h2>
      </div>

      <div class="d-flex justify-center align-center" v-if="step1">
        <v-row>
          <VCol cols="12" sm="12" md="12" class="fromandto py-0 mb-5">
            <VAutocomplete
              v-model="selectedFromcountry"
              label="ORIGIN COUNTRY"
              :items="filteredCountryNames"
              required
              :rules="overallFormValidation"
              variant="solo"
            />
          </VCol>
          <VCol cols="12" sm="12" md="12" class="fromandto py-0 mb-5">
            <div style="position:relative;">
              <VTextField
                v-model="fromPostalcode"
                label="ORIGIN POSTALCODE / LOCATION"
                required
                :rules="overallFormValidation"
                variant="solo"
                @click="fromPostalUl = true"
              />
              <div v-if="postalFrom" style="position: absolute;
                right: 15px;top: 15px;">
                <v-progress-circular
                  color="primary"
                  :size="18"
                  :width="2"
                  indeterminate
                ></v-progress-circular>
              </div>
            </div>
            <ul
              v-if="fromPostalcodeList.length > 0 && fromPostalUl"
              class="dropdowdata"
            >
              <li
                v-for="postalCode in fromPostalcodeList"
                :key="postalCode"
                @click="
                  selectedFromPostal(postalCode.zipcode, postalCode.cityname)
                "
              >
                {{ postalCode.zipcode }}-{{ postalCode.cityname }}
              </li>
            </ul>
          </VCol>

          <VCol cols="12" sm="12" md="12" class="fromandto py-0 mb-5">
            <VAutocomplete
              v-model="selectedTocountry"
              label="DESTINATION COUNTRY"
              :items="filteredCountryNames"
              required
              :rules="overallFormValidation"
              variant="solo"
            />
          </VCol>
          <VCol cols="12" sm="12" md="12" class="fromandto py-0 mb-5">
            <div style="position:relative">
            <VTextField
              v-model="toPostalcode"
              label="DESTINATION POSTALCODE / LOCATION"
              required
              :rules="overallFormValidation"
              variant="solo"
              @click="toPostalUl = true"
            />
            <div v-if="postalTo" style="position: absolute;
                right: 15px;top: 15px;">
                <v-progress-circular
                  color="primary"
                  :size="18"
                  :width="2"
                  indeterminate
                ></v-progress-circular>
              </div>
            </div>
            <ul
              v-if="toPostalcodeList.length > 0 && toPostalUl"
              class="dropdowdata"
            >
              <li
                v-for="postcode in toPostalcodeList"
                :key="postcode"
                @click="selectedToPostal(postcode.zipcode, postcode.cityname)"
              >
                {{ postcode.zipcode }}-{{ postcode.cityname }}
              </li>
            </ul>
          </VCol>
          <VCol col="9" />
          <VCol
            v-if="pickupDelblockBtn == true"
            cols="4" sm="6" md="3"
            class="d-flex justify-end mb-5"
          >
            <VBtn
              :disabled="
                countryPostalcontTo == false || countryPostalcontFrom == false
              "
              class="but-color"
              @click="
                (pickupDelblock = true),
                  (pickupDelblockBtn = false),
                  (shipmentblockBtn = true),
                  (step = true)
              "
            >
              CONTINUE
            </VBtn>
          </VCol>
        </v-row>
      </div>

      <div>
        <div v-if="step">
          <VRow>
            <VCol cols="12" sm="12" md="12">
              <h5>Tell us more about pickup and delivery</h5>
            </VCol>
            <VCol cols="12">
              <h6>COLLECTION</h6>
            </VCol>

            <VCol cols="6" class="radioMargins">
              <VSelect
                v-model="pickupHub"
                label="Pickup/Hub"
                :items="['DOOR STEP - PICKUP', 'DELIVERY AT HUB']"
                variant="solo"
                placeholder=""
              />
            </VCol>
            <VCol cols="6" class="radioMargins">
              <VSelect
                v-model="pickupResi"
                label="Residential/Commercial"
                :items="['COMMERCIAL', 'RESIDENTIAL']"
                variant="solo"
                placeholder=""
              />
            </VCol>
            <!-- <VCol cols="12" /> -->
            <VCol cols="12">
              <h6>DELIVERY</h6>
            </VCol>

            <VCol cols="6" class="radioMargins">
              <VSelect
                v-model="deliveryHub"
                label="Delivery/Hub"
                :items="['DOOR DELIVERY', 'PICKUP FROM HUB']"
                variant="solo"
                placeholder=""
              />
            </VCol>
            <VCol cols="6" class="radioMargins">
              <VSelect
                v-model="deliveryResi"
                label="Residential/Commercial"
                :items="['COMMERCIAL', 'RESIDENTIAL']"
                variant="solo"
                placeholder=""
              />
            </VCol>

            <div class="col-12">
              <h5>Do You Have Any Special Requirement?</h5>
              <div class="text-area">
                <v-textarea variant="outlined"></v-textarea>
              </div>
            </div>
            <VCol
              v-if="shipmentblockBtn == true"
              cols="12"
              class="d-flex justify-end mb-5"
            >
              <VBtn
                @click="
                  (shipmentblock = true),
                    (shipmentblockBtn = false),
                    (step2 = true),
                    (step1 = false),
                    (step = false)
                "
                class="but-color"
              >
                CONTINUE
              </VBtn>
            </VCol>
          </VRow>
        </div>
      </div>

      <!-- quote request form -->

      <!-- <div v-if="step2"></div> -->

      <div v-if="step2">
        <VForm class="formelements" @submit.prevent="openOverlay = true">
          <VRow>
            <VCol cols="12" sm="12" md="12" />

            <!-- shipment block -->

            <VCol cols="12" sm="12" md="12" />
            <VRow v-if="shipmentblock == true">
              <VCol cols="12" sm="12" md="12">
                <h5>Tell us more about your shipment</h5>
              </VCol>
              <VCol cols="9">
                <VSelect
                  v-model="selectedPackage"
                  label="PACKAGE TYPE"
                  :items="[
                    'BOX',
                    'PALLET',
                    'ENVELOPE',
                    'SATCHEL',
                    'ROLL',
                    'DRUM',
                    'CRATE',
                    'BAG',
                    'CARTON',
                  ]"
                  variant="solo"
                  placeholder="PACKAGE TYPE"
                />
              </VCol>
              <VCol cols="3">
                <VSelect
                  v-model="unit"
                  label="UNIT"
                  :items="['KG', 'LB']"
                  variant="solo"
                  placeholder=""
                  class="unitinput"
                />
              </VCol>
              <VCol cols="12" sm="12" md="12">
                <VTable>
                  <thead>
                    <tr>
                      <th>
                        <h6>No.of Packages</h6>
                      </th>
                      <th>
                        <h6>Weight per package</h6>
                        <!-- <p>{{ `(${unit})` }}</p> -->
                      </th>
                      <th>
                        <h6>Dimensions per package</h6>
                        <!-- <p>{{ `L(${measurement}) X W(${measurement}) X H(${measurement})` }}</p> -->
                      </th>
                    </tr>
                  </thead>
                  {{ console.log(addItemQuote, "addItemQuote") }}
                  <tbody
                    v-for="(items, index) in addItemQuote"
                    :key="index"
                    class="measureSection"
                  >
                    <tr>
                      <td>
                        <div class="title-sub">QUANTITY <span>*</span></div>
                        <input
                          class="in-design"
                          v-model="items.quantity"
                          type="number"
                          inputmode="numeric"
                          placeholder=""
                          required
                          :rules="lastrowValidation"
                        />
                      </td>
                      <td>
                        <div class="title-sub">
                          WEIGHT({{ unit }}) <span>*</span>
                        </div>
                        <input
                          class="in-design"
                          v-model="items.weight"
                          maxlength="4"
                          type="number"
                          inputmode="numeric"
                          placeholder=""
                          required
                          :rules="lastrowValidation"
                          outlined
                        />
                      </td>
                      <td>
                        <VTable>
                        <tbody>
                        <tr>
                          <td>
                            <div class="title-sub">
                              L({{ measurement }}) <span>*</span>
                            </div>
                            <input
                              v-model="items.length"
                              class="in-design"
                              type="number"
                              maxlength="4"
                              inputmode="numeric"
                              placeholder=""
                              required
                              :rules="lastrowValidation"
                              outlined
                            />
                          </td>
                          <td class="measurementSymbol">
                            &nbsp;
                            <b>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="icon icon-tabler icon-tabler-x"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="#2c3e50"
                                fill="none"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              >
                                <path
                                  stroke="none"
                                  d="M0 0h24v24H0z"
                                  fill="none"
                                />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                              </svg>
                            </b>
                            &nbsp;
                          </td>
                          <td>
                            <div class="title-sub">
                              W({{ measurement }}) <span>*</span>
                            </div>
                            <input
                              v-model="items.width"
                              class="in-design"
                              maxlength="4"
                              type="number"
                              inputmode="numeric"
                              placeholder=""
                              required
                              :rules="lastrowValidation"
                              outlined
                            />
                          </td>
                          <td class="measurementSymbol">
                            &nbsp;
                            <b
                              ><svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="icon icon-tabler icon-tabler-x"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="#2c3e50"
                                fill="none"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              >
                                <path
                                  stroke="none"
                                  d="M0 0h24v24H0z"
                                  fill="none"
                                />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                              </svg>
                            </b>
                            &nbsp;
                          </td>
                          <td>
                            <div class="title-sub">
                              H({{ measurement }}) <span>*</span>
                            </div>
                            <input
                              v-model="items.height"
                              outlined
                              maxlength="4"
                              class="in-design"
                              type="number"
                              inputmode="numeric"
                              placeholder=""
                              required
                              :rules="lastrowValidation"
                            />
                          </td>
                          <td>
                            <VCol v-if="index > 0">
                              <VBtn
                                color="#ed1c24"
                                class="removeBtn"
                                @click="removePackage(index)"
                              >
                                X
                              </VBtn>
                            </VCol>
                          </td>
                        </tr>
                        </tbody>
                        </VTable>
                      </td>
                    </tr>
                  </tbody>
                </VTable>
              </VCol>
              <VCol
                cols="3"
                md="3"
                sm="3"
                style="margin-block-start: -20px !important"
              >
                <VBtn block color="#22224d" variant="plain" @click="addPackage">
                  <h6 class="ms-5">
                    <span style="color: #22224d">+ ADD ANOTHER PACKAGE</span>
                  </h6>
                </VBtn>
              </VCol>
              <!-- <VCol cols="12" md="12" sm="12"> -->
              <VDivider class="m-0" />
              <!-- </VCol> -->
              <VCol v-if="totPackages > 0" cols="2" md="2" sm="2">
                <VTextField
                  v-model="totPackages"
                  label="PACKAGES"
                  variant="underlined"
                  append-inner-icon="tabler-packages"
                />
              </VCol>
              <VCol v-if="totWeight > 0" cols="2" md="2" sm="2">
                <VTextField
                  v-model="totWeight"
                  label="TOTAL WEIGHT"
                  variant="underlined"
                  append-inner-icon="tabler-weight"
                >
                  <!-- {{ totWeight }} ({{ unit }}) -->
                </VTextField>
                <!-- <span>{{ unit }}</span> -->
              </VCol>
              <!-- <VCol cols="12" sm="12" md="12" /> -->
              <VCol cols="12" sm="12" md="12">
                <h5 class="m-0">Tell us about your selectedCurrency</h5>
              </VCol>
              <VCol cols="12" md="12" lg="12" class="pb-0">
                <VSelect
                  v-model="selectedCurrency"
                  label="selectedCurrency"
                  :items="['AED','INR','LKR','AUD','CAD','USD']"
                  variant="solo"
                  placeholder=""
                />
              </VCol>
              <VCol cols="12" sm="12" md="12" class="pt-0">
                <h5 class="m-0">When do you want to ship?</h5>
              </VCol>
              <VCol cols="12" sm="12" md="12" class="fromandto">
                <VTextField
                  v-model="shipdateQuote"
                  label="SHIP DATE"
                  type="date"
                  placeholder="YYYY-MM-DD"
                  variant="solo"
                  :min="getCurrentDate()"
                  :rules="overallFormValidation"
                  required
                />
              </VCol>
              <VCol cols="7" />
              <VCol
                cols="5"
                md="5"
                sm="5"
                class="mb-5"
                style="margin-bottom: 50px !important"
              >
                <VBtn
                  block
                  type="submit"
                  :disabled="!formValidation"
                  class="py-3 but-color"
                   @click="getQuote()"
                >
                  SHOW RATES
                </VBtn>
              </VCol>
            </VRow>
          </VRow>
        </VForm>
      </div>
      </v-container>
  </div>
      <!-- quote response -->

</template>

<script>
import countryList from "@/countries.json";
import moment from "moment";
import axios from "axios";
// import VueDatePicker from "@vuepic/vue-datepicker";
import country1 from "@/coundtrycode.json";
export default {
  components: {
    // VueDatePicker,
  },
  data() {
    return {
      addItemQuote: [
        {
          quantity: 1,
          weight: "",
          length: "",
          width: "",
          height: "",
        },
      ],
      shipId: "",
      countrycode: [],
      quoteSelected: {},
      quoteselectedId: "",
      QuoteData: "",
      loader4: false,
      shingData: [],
      Destination: false,
      step1: true,
      step: false,
      step2: false,
      step3: false,
      step4: false,
      step5: false,
      step6: false,
      postalFrom:false,
      postalTo:false,
      quoteform: false,
      bookingRefId: "",
      selectedPackage: "BOX",
      selectedFromcountry: null,
      PickupResiQuote: "COMMERCIAL",
      DeliveryResiQuote: "COMMERCIAL",
      DeliveryResiQuote1: "COMMERCIAL1",
      selectedPickupQuote: "PICKUP",
      selectedDeliveryQuote: "DELIVERY",
      selectedDeliveryQuote1: "DELIVERY1",
      selectedPickupQuote1: "PICKUP1",
      selectedTocountry: null,
      fromPostalcode: "",
      toPostalcode: "",
      fromCity: "",
      toCity: "",
      postalsplittedFrom: "",
      formTotalData: [],
      postalsplittedTo: "",
      fromPostalcodeList: [],
      toPostalcodeList: [],
      pickupHub: "DELIVERY AT HUB",
      deliveryHub: " DOOR DELIVERY",
      pickupResi: "COMMERCIAL",
      deliveryResi: "COMMERCIAL",
      measurement: "cm",
      unit: "KG",
      totPackages: 0,
      totWeight: 0,
      selectedCurrency: "AED",
      shipdateQuoteQuote: "",
      // shipdateQuotelist: [],
      shipdateQuote: "",
      carrierquote: "",
      targequote: "",
      quoteId: "",
      quoteResponse: [],
      selectedQuoteResponseId: "",
      selectedQuoteResponseData: "",
      shipmetData: false,
      countryListarray: [],
      fromcountryCode: [],
      tocountryCode: [],
      dateFormat: "dd MMM, yyyy",
      fromPostalUl: false,
      toPostalUl: false,

      openOverlay: false,
      popupform: false,
      popupTopDetails: true,
      finalAlert: false,

      //carrierLogo
      carrierLogoPrefix: "https://about:blank",

      // rules

      lastrowValidation: [
        (v) => !!v || "Please enter a valid input",
        (v) => /^[0-9]*$/.test(v) || "Only numeric values are allowed",
      ],
      overallFormValidation: [(v) => !!v || "Please enter a valid input"],
      // emailRequire: [
      //   v => !!  "Please enter a valid input",
      //   v => /.+@.+\..+/.test(v) || "Please enter a valid email address",
      // ],
      targequoterule: [
        (v) => /^[0-9+ -]*$/.test(v) || "Only numeric values are allowed",
        // (value) => {
        //   if (value?.length === 5) return true;
        //   return "Contact number must be 5 characters long.";
        // },
        (v) => !!v || "Please enter a valid input",
      ],
      contactRules: [
        (value) => {
          if (value?.length >= 5) return true;

          return "Enter a valid  number.";
        },
        (v) => !!v || "Please enter a valid input",
        (v) => /^[0-9+ -]*$/.test(v) || "Only numeric values are allowed",
      ],
      //quoterequest hide and show variables
      // addItemQuote: [
      //   {
      //     selectedPackageQuote: "BOX",
      //     weightQuote: "",
      //     quantityQuote: "",
      //     heightQuote: "",
      //     widthQuote: "",
      //     lengthQuote: "",
      //   },
      // ],
      countryPostalcontFrom: false,
      countryPostalcontTo: false,
      pickupDelblock: false,
      pickupDelblockBtn: true,
      shipmentblock: false,
      shipmentblockBtn: false,

      //loaders
      responseLoader: false,
      sendMailLoader: false,

      goLoader: false,
      goLoader1: false,
      // popupdata
      popupName: "",
      popupEmail: "",
      popupContact: "",

      quoteResponsedisp: false,
       endpoint:"",
      //bookingoverlay
      bookingOverlay: false,
      bookingoverlayStep1: true,
      bookingoverlayStep2: false,
      bookingoverlayStep3: false,
      targertotal: false,
      // bookingform data
      valied1: false,
      valied2: false,
      valied3: false,
      Sendername: "",
      Receivername: "",
      Senderemail: "",
      selectedItemQuote: "PARCEL/CARTON/BAGGAGE",
      Receiveremail: "",
      Sendercompany: "",
      Receivercompany: "",
      Sendermobile: "",
      Receivermobile: "",
      Senderaddress1: "",
      Receiveraddress1: "",
      Senderaddress2: "",
      Receiveraddress2: "",
      Senderaddress3: "",
      Receiveraddress3: "",
      Sendercity: "",
      Receivercity: "",
      Senderzipcode: "",
      Receiverzipcode: "",
      bookingcontentDescription: "",
      bookingPickupdate: "",
      senderDialCode: "",
      receverDialCode: "",
    };
  },
  computed: {
    filteredCountryNames() {
      countryList.forEach((item) => {
        return this.countryListarray.push({
          code: item.code,
          country: item.name,
        });
      });

      return countryList.map((country) => country.name);
    },

   
    formValidation() {
      return (
        this.selectedFromcountry !== "" &&
        this.selectedTocountry !== "" &&
        this.totPackages !== "" &&
        this.totWeight !== "" &&
        this.shipdateQuote !== "" &&
        this.addItemQuote.every(
          (item) =>
            item.weight !== "" &&
            item.quantity !== "" &&
            item.height !== "" &&
            item.length !== "" &&
            item.width !== ""
        )
      );
    },
    booknowValidation() {
      return (
        this.Senderaddress1 !== "" &&
        this.Senderaddress2 !== "" &&
        this.Receivername !== "" &&
        this.Receiveremail !== "" &&
        this.validateEmail(this.Receiveremail) &&
        this.Receivermobile !== "" &&
        this.Receivermobile.length >= 5 &&
        this.validateContact(this.Receivermobile) &&
        this.Receiveraddress1 !== "" &&
        this.Receiveraddress2 !== "" &&
        this.bookingcontentDescription !== "" &&
        this.checkCompanySender(this.pickupResi) &&
        this.checkCompanyReceiver(this.deliveryResi)
      );
    },
    popupformValidation() {
      return (
        this.popupName !== "" &&
        this.popupEmail !== "" &&
        this.validateEmail(this.popupEmail) &&
        this.popupContact !== "" &&
        this.validateContact(this.popupContact)
      );
    },
  },
  watch: {
    selectedFromcountry(newval) {
      console.log(newval, "newval");
      this.fromcountryCode = [];
      this.fromPostalcodeList = [];
      // this.fromPostalcode = null;
      this.countryListarray.filter((item) => {
        console.log(item, "itemitem2222222 ");
        if (item.country === newval) {
          this.fromcountryCode.push(item);
        }
      });
    },
    selectedTocountry(newval) {
      console.log(newval, "newval");
      this.tocountryCode = [];
      this.toPostalcodeList = [];
      // this.toPostalcode = null;
      this.countryListarray.filter((item) => {
        console.log(item, "itemitem2222222 ");
        if (item.country === newval) {
          this.tocountryCode.push(item);
        }
      });
    },
    addItemQuote(newval) {
      console.log(newval, "pppp");
      newval.forEach((c, i) => {
        if (c[i].weight.length > 4) {
          c[i].weight += c[i].weight;
        }
      });
    },
    unit(val) {
      if (val == "KG") {
        this.measurement = "cm";
      } else if (val == "LB") {
        this.measurement = "in";
      }
    },
    
    shipdateQuote(val) {
      this.shipdateQuoteTosend = moment(val).format("YYYY-MM-DD");
      console.log(this.shipdateQuoteTosend, "shipdat_tosend");
    },
    async fromPostalcode(val) {
    if( val && val.length == 3 ){
      this.postalFrom= true
      }
      else if( val && val.length < 3 ){
        this.postalFrom= false
      }
      if (val && this.fromcountryCode.length > 0) {
        let PostalData = {
          enteredvalue: val,
          countrycode: this.fromcountryCode[0].code,
        };
        console.log(PostalData, "PostalData");
        if (val.length >= 3) {
          await axios
            .post(
              `https://xportal.skyrouteexpress.com/api/postalapi`,
              PostalData,
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            )
            .then((response) => {
              console.log(response, "responseresponse");
              this.postalFrom= false
              this.fromPostalcodeList = response.data.map((item) => ({
                cityname: item.name,
                zipcode: item.zip_code,
              }));
            });
          console.log(
            this.fromPostalcodeList,
            this.fromPostalUl,
            "frompostallist"
          );
        }
      }
    },
    toPostalcode(valto) {
      console.log(this.tocountryCode, "pppp");
      if( valto && valto.length == 3 ){
        this.postalTo= true
      }
      else if( valto && valto.length < 3 ){
        this.postalTo= false
      }
      if (valto && this.tocountryCode.length > 0) {
        let PostalDataTo = {
          enteredvalue: valto,
          countrycode: this.tocountryCode[0].code,
        };
        if (valto.length >= 3) {
          axios
            .post(
              `https://xportal.skyrouteexpress.com/api/postalapiTo`,
              PostalDataTo,
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            )
            .then((response) => {
            this.postalTo= false
              this.toPostalcodeList = response.data.map((items) => ({
                cityname: items.name,
                zipcode: items.zip_code,
              }));
            });
        }
      }
    },
  },

  methods: {

async getQuote() {
      this.calculateTotalWeightAndQuantity();
      this.loader1 = true;
      // sessionStorage.setItem('portalCurrency',this.selectedCurrency)
      console.log(this.totPackages, this.totWeight, "totWeight");
      let quotedata = {
        fromCountry: this.selectedFromcountry,
        fromPostal: this.fromPostalcode,
        fromcity: this.fromCity,
        toCountry: this.selectedTocountry,
        toPostal: this.toPostalcode,
        tocity: this.toCity,
        pickup: this.selectedPickupQuote,
        delivery: this.selectedDeliveryQuote,
        pickupresi: this.PickupResiQuote,
        deliveryresi: this.DeliveryResiQuote,
        shipDate: moment(this.shipdateQuote).format("YYYY-MM-DD"),
        itemtype: this.selectedItemQuote,
        currency: this.selectedCurrency,
        fromcountrycode: this.fromcountryCode[0].code,
        tocountrycode: this.tocountryCode[0].code,
        unit: this.measurement,
        quoteId: Math.ceil(Math.random() * 1000000),
        packageType:this.selectedPackage,
        totalQuantity: this.totPackages,
        totalWeight: this.totWeight,
        items: this.addItemQuote.map((item) => ({
          weight: item.weight,
          length: item.length,
          height: item.height,
          width: item.width,
          quantity: item.quantity,
          packageType:this.selectedPackage,
        })),
      };

      // let originalDate = new Date(this.shipdateQuoteQuote);
      // let twodaysLater = new Date(originalDate);
      // twodaysLater.setDate(originalDate.getDate() + 2);
      // this.pickupdate = twodaysLater.toISOString().slice(0, 10);

      this.mobileSender = this.contactNum;
      this.nameSender = this.username;
      this.emailSender = this.useremail;

      this.getquoteloader = true;

      console.log(quotedata, "quotedata");
      try {
        const response = await axios.post(
          `https://xportal.skyrouteexpress.com/api/getquotecache`,
          quotedata,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log(response.data.quoteProcessId, "response ..");

        if (response.data.quoteProcessId) {
          const quoteProcessId = response.data.quoteProcessId;
      //  const vNewUrl = `https://skyrouteexpbook.vercel.app/index.php/quoteresponse?quoteRequest_id=${quoteProcessId}`;
      //  window.open(vNewUrl, "_blank");
      this.$router.push({
        path: "/formResponse",
        query: { quoteRequest_id: quoteProcessId }
      })
      // const vueUrl = `https://skyrouteexpbook.vercel.app/formResponse?quoteRequest_id=${quoteProcessId}`;

      // const formData = new FormData();
      // formData.append("action", "save_vue_url");
      // formData.append("vue_url", vueUrl);

      // await axios.post("https://skyrouteexpress.com//wp-admin/admin-ajax.php", formData);
        }
      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
      }

      console.log(quotedata, "quotedataquotedata");
    },


   

    changeurl() {
      window.open(`https://xportal.skyrouteexpress.com`, "_blank");
    },
    calculateTotalWeightAndQuantity() {
      this.totPackages = 0;
      this.totWeight = 0;
      this.addItemQuote.filter((total) => {
        console.log(total, "totaltotal");
        this.totPackages =
          parseInt(this.totPackages) + parseInt(total.quantity);
        this.totWeight =
          parseInt(this.totWeight) + parseInt(total.quantity * total.weight);
      });

      console.log(this.totPackages, this.weightQuote, "  this.totWeight ");
    },

    
    removeItemQuote(index) {
      this.addItemQuote.splice(index, 1);
    },

    dataChange($event) {
      // console.log()
      return moment($event).format("DD-MMM-YYYY");
    },
   
    validateEmail(email) {
      return /.+@.+\..+/.test(email);
    },
    validateContact(contact) {
      return /^[0-9+ -]*$/.test(contact);
    },
    checkCompanySender(companysender) {
      if (
        (companysender == "COMMERCIAL" && this.Sendercompany !== "") ||
        (companysender == "RESIDENTIAL" &&
          (this.Sendercompany == "" || this.Sendercompany !== ""))
      ) {
        return true;
      }
    },
    checkCompanyReceiver(companyreceiver) {
      if (
        (companyreceiver == "COMMERCIAL" && this.Receivercompany !== "") ||
        (companyreceiver == "RESIDENTIAL" &&
          (this.Receivercompany == "" || this.Receivercompany !== ""))
      ) {
        return true;
      }
    },
    selectedFromPostal(data1, data2) {
      if (data1 == null) {
        data1 = "";
        this.fromPostalcode = `${data1}-${data2}`;
      } else {
        this.fromPostalcode = `${data1} - ${data2}`;
      }
      this.fromPostalUl = false;
      this.postalsplittedFrom = this.fromPostalcode.split("-");
      this.fromCity = this.postalsplittedFrom[1];
      this.countryPostalcontFrom = true;
    },
    selectedToPostal(data1, data2) {
      if (data1 == null) {
        data1 = "";
        this.toPostalcode = `${data1}-${data2}`;
      } else {
        this.toPostalcode = `${data1} - ${data2}`;
      }
      this.toPostalUl = false;
      this.postalsplittedTo = this.toPostalcode.split("-");
      this.toCity = this.postalsplittedTo[1];
      this.countryPostalcontTo = true;
    },
    addPackage() {
      this.addItemQuote.push({
        quantity: "",
        weight: "",
        length: "",
        width: "",
        height: "",
      });
    },
    removePackage(index) {
      this.addItemQuote.splice(index, 1);
    },
   
    momentfuncArrivalDt(date) {
      return moment(date).format("YYYY-MMM-DD");
    },

    // momentfunc(datelist){
    //   return datelist.map(element=>moment(element).format('dddd, MMMM DD, YYYY'))
    // },
    getCurrentDate() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      let month = currentDate.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      let day = currentDate.getDate();
      day = day < 10 ? "0" + day : day;

      return `${year}-${month}-${day}`;
    },
    postalZipcodefunc() {
      if (
        this.postalsplittedFrom[0] == "" ||
        this.postalsplittedFrom[0] == null
      ) {
        this.Senderzipcode = this.postalsplittedFrom[1];

        return (this.fromPostalcode = this.postalsplittedFrom[1]);
      } else {
        this.Senderzipcode = this.postalsplittedFrom[0];

        return (this.fromPostalcode = this.postalsplittedFrom[0]);
      }
    },
    postalZipcodeTofunc() {
      if (this.postalsplittedTo[0] == "" || this.postalsplittedTo[0] == null) {
        this.Receiverzipcode = this.postalsplittedTo[1];

        return (this.toPostalcode = this.postalsplittedTo[1]);
      } else {
        this.Receiverzipcode = this.postalsplittedTo[0];

        return (this.toPostalcode = this.postalsplittedTo[0]);
      }
    },
   

    async getQuote1() {
      let quotedata = this.shingData;

      this.getquoteloader = true;
      console.log(quotedata, "quotedataquotedata");
      try {
        const response = await axios.post(
          `https://xportal.skyrouteexpress.com/api/getquote2`,
          quotedata,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        this.goLoader = false;

        this.getQuoteId = quotedata.getQuoteId;
        console.log(this.getQuoteId, "getquoteid");
        console.log(response, "apiresponseee");
        this.responseLoader = false;
        this.quoteResponsedisp = true;
        (this.responseLoader = true), (this.step3 = false), (this.step4 = true);
        this.quoteResponse = response.data.QuoteResponse2.data._RatesResponce;
        console.log(
          response.data.QuoteResponse2.data._RatesResponce,
          "response.data._RatesResponce"
        );
      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
      }
    },
    targetsource() {
      this.targertotal = false;
      this.step4 = true;
      this.openOverlay = true;
    },
    async popupForm() {
      this.goLoader = true;
      if (this.shipId) {
        // this.quoteResponse = this.shingData;

        let passDeatils = {
          Name: this.popupName,
          Email: this.popupEmail,
          Contact: this.popupContact,
          QuoteProcessId: this.shipId,
        };
        console.log(passDeatils, "passDeatils");
        try {
          const response = await axios.post(
            `https://xportal.skyrouteexpress.com/api/cachePopupformdata`,
            passDeatils,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          console.log(response, "responsevvvv");

          if (response.data.QuoteResponseCache.data._RatesResponce.length > 0) {
            this.goLoader = false;
            console.log(response, "apiresponseee");
            this.responseLoader = false;
            this.quoteResponsedisp = true;
            (this.responseLoader = true),
              (this.step3 = false),
              (this.step4 = true);
            if (
              response.data.QuoteResponseCache.data._RatesResponce[0] ==
              "restricted"
            ) {
              this.step6 = true;
            } else {
              this.quoteResponse =
                response.data.QuoteResponseCache.data._RatesResponce;
            }
          } else {
            this.goLoader = false;
            this.Destination = true;
          }

          console.log(
            response.data.QuoteResponseCache.data._RatesResponce,
            "response.data._RatesResponce"
          );
        } catch (error) {
          console.error("There was a problem with the fetch operation:", error);
        }
      } else {
        this.getQuote();
      }

      // let popupData = {
      //   Name: this.popupName,
      //   Email: this.popupEmail,
      //   Contact: this.popupContact,
      //   QuoteRequestId: this.quoteId,
      // };

      // this.Sendername = this.popupName;
      // this.Senderemail = this.popupEmail;
      // this.Sendermobile = this.popupContact;
      // console.log(this.Sendername, this.Senderemail, this.Sendermobile);
      // console.log(popupData, "popupDatapopupDatapopupDatapopupData");

      // axios
      //   .post(
      //     `https://xportal.skyrouteexpress.com/api/popupformdata`,
      //     popupData,
      //     {
      //       headers: {
      //         "Content-Type": "application/json",
      //       },
      //     }
      //   )
      //   .then((response) => {
      //     console.log(response.data.success, "popup_datasaving");
      //     this.openOverlay = false;
      //     this.responseLoader = false;
      //     this.quoteResponsedisp = true;
      //   })
      //   .catch((error) => {
      //     console.error("Error in saving details", error);
      //   });
    },
    sendMail(event) {
      this.sendMailLoader = true;
      if (
        this.valied1 &&
        this.valied1 &&
        this.bookingcontentDescription &&
        this.bookingPickupdate
      ) {
        // this.step5 = false;
        this.step6 = true;

        console.log(event, "event");
        let bookingformdata = {
          Sendername: this.Sendername,
          Receivername: this.Receivername,
          Senderemail: this.Senderemail,
          Receiveremail: this.Receiveremail,
          Sendercompany: this.Sendercompany,
          Receivercompany: this.Receivercompany,
          Sendermobile: this.Sendermobile,
          Receivermobile: this.Receivermobile,
          Senderaddress1: this.Senderaddress1,
          Receiveraddress1: this.Receiveraddress1,
          Senderaddress2: this.Senderaddress2,
          Receiveraddress2: this.Receiveraddress2,
          Senderaddress3: this.Senderaddress3,
          Receiveraddress3: this.Receiveraddress3,
          Sendercity: this.Sendercity,
          Receivercity: this.Receivercity,
          Senderzipcode: this.Senderzipcode,
          Receiverzipcode: this.Receiverzipcode,
          bookingPickupdate: moment(this.bookingPickupdate).format(
            "YYYY-MM-DD"
          ),
          bookingcontentDescription: this.bookingcontentDescription,
        };
        this.selectedQuoteResponseData =
          this.quoteResponse["_RatesResponce"][this.selectedQuoteResponseId];

        let booknowData = {
          formId: this.quoteId,
          quoteselected: this.selectedQuoteResponseData,
          quoteselectedId: this.selectedQuoteResponseId,
          quoteSelected: this.selectedQuoteResponseData,
          bookingformdata: bookingformdata,
        };
        console.log(booknowData, "booknowData");
        axios
          .post(
            `https://xportal.skyrouteexpress.com/api/getQuoteMail2`,
            booknowData,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            this.finalAlert = true;
            this.sendMailLoader = false;

            console.log(response, "responseeee");
            return response.data;
          })
          .catch((error) => {
            this.sendMailLoader = false;
            console.error("There was a problem with this operation:", error);
          });
      }
    },
    sendMailAlertFunc() {
      this.finalAlert = false;
      if (!this.finalAlert) {
        window.location.href =
          "https://xportal.skyrouteexpress.com/requestform2";
      }
    },
    shingConvertData() {
      this.shipId = this.$route.query.quoteRequest_id;

      // console.log(this.$route.query.quoteData, window.location, "pppp");
      if (this.shipId) {
        this.step1 = false;
        this.popupTopDetails = true;
        this.openOverlay = true;

        let $data = {
          quoteProcessId: this.shipId,
        };
        axios
          .post(
            `https://xportal.skyrouteexpress.com/api/quoterequestdetails`,
            $data,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            this.formTotalData = JSON.parse(
              response.data.quoterequestdetails.QuoteRequestData
            );
            console.log(this.formTotalData, "this.formTotalData");
            this.selectedFromcountry = this.formTotalData.fromCountry;
            this.fromPostalcode = this.formTotalData.fromPostal;
            this.selectedTocountry = this.formTotalData.toCountry;
            this.toPostalcode = this.formTotalData.toPostal;
            this.addItemQuote = this.formTotalData.items;
            // this.selectedDeliveryQuote = this.formTotalData.pickup;
            // this.DeliveryResiQuote = this.formTotalData.pickupresi;
            // this.selectedDeliveryQuote1 = this.formTotalData.delivery;
            // this.DeliveryResiQuote1 = this.formTotalData.deliveryresi;
            // console.log(this.formTotalData.items, "this.formTotalData");

            //prefill booking form with postal and city details:
            this.Senderzipcode = this.formTotalData.fromPostal;
            this.Sendercity = this.formTotalData.fromcity;
            this.Receiverzipcode = this.formTotalData.toPostal;
            this.Receivercity = this.formTotalData.tocity;

          })
          .catch((error) => {
            console.error("There was a problem with this operation:", error);
          });
      }
    },
    delivared(response, index) {
      console.log(response, index, "response, index");
      this.quoteSelected = response;
      this.quoteselectedId = index;
    },
    async getEmail() {
      this.loader4 = true;
      if (
        this.valied1 &&
        this.valied2 &&
        this.bookingcontentDescription &&
        this.bookingPickupdate
      ) {
        let $getEmail = {
          formId: this.shipId,
          quoteselectedId: this.quoteselectedId,

          quoteSelected: {
            IsCodApplicable: this.quoteSelected.IsCodApplicable,
            TopayCharges: this.quoteSelected.TopayCharges,
            CodCharges: this.quoteSelected.CodCharges,
            ODACharges: this.quoteSelected.ODACharges,
            DocketCharge: this.quoteSelected.DocketCharge,
            FreightRate: this.quoteSelected.FreightRate,
            Weight: this.quoteSelected.Weight,
            CompanyId: this.quoteSelected.CompanyId,
            CarrierName: this.quoteSelected.CarrierName,
            ServiceName: this.quoteSelected.ServiceName,
            ServiceId: this.quoteSelected.ServiceId,
            CarrierId: this.quoteSelected.CarrierId,
            DocType: this.quoteSelected.DocType,
            maxPrice: this.quoteSelected.maxPrice,
            minPrice: this.quoteSelected.minPrice,
            GrandTotal: this.quoteSelected.GrandTotal,
            SubTotal: this.quoteSelected.SubTotal,
            IsError: this.quoteSelected.IsError,
            TaxName1: this.quoteSelected.TaxName1,
            TaxAmount1: this.quoteSelected.TaxAmount1,
            TaxName2: this.quoteSelected.TaxName2,
            TaxAmount2: this.quoteSelected.TaxAmount2,
            TaxName3: this.quoteSelected.TaxName3,
            TaxAmount3: this.quoteSelected.TaxAmount3,
            TaxName4: this.quoteSelected.TaxName4,
            TaxAmount4: this.quoteSelected.TaxAmount4,
            TotalTax: this.quoteSelected.TotalTax,
            OrgLcnId: this.quoteSelected.OrgLcnId,
            DestLcnId: this.quoteSelected.DestLcnId,
            FuelSurcharge: this.quoteSelected.FuelSurcharge,
            Othercharges: this.quoteSelected.Othercharges,
            RateEntryType: this.quoteSelected.RateEntryType,
            CovidCharge: this.quoteSelected.CovidCharge,
            VolumetricWgtDenominator:
              this.quoteSelected.VolumetricWgtDenominator,
            IsSpotRate: this.quoteSelected.IsSpotRate,
            FOVType: this.quoteSelected.FOVType,
            FOVCharge: this.quoteSelected.FOVCharge,
            DeliveryDate: this.quoteSelected.DeliveryDate,
            CarrierLogo: this.quoteSelected.CarrierLogo,
            IsAWBChargesApplicable: this.quoteSelected.IsAWBChargesApplicable,
            ToPayApplicable: this.quoteSelected.ToPayApplicable,
            AWBCharges: this.quoteSelected.AWBCharges,
            no_of_days_to_deliver: this.quoteSelected.no_of_days_to_deliver,
          },

          bookingformdata: {
            Sendername: this.Senderemail,
            Receivername: this.Receivername,
            Senderemail: this.Senderemail,
            Receiveremail: this.Receiveremail,
            Senderdialcode: this.senderDialCode,
            Receiverdialcode: this.receverDialCode,
            Sendercompany: this.Sendercompany,
            Receivercompany: this.Receivercompany,
            Sendermobile: this.Sendermobile,
            Receivermobile: this.Receivermobile,
            Senderaddress1: this.Senderaddress1,
            Receiveraddress1: this.Receiveraddress2,
            Senderaddress2: this.Senderaddress2,
            Receiveraddress2: this.Receiveraddress2,
            Senderaddress3: this.Senderaddress3,
            Receiveraddress3: this.Receiveraddress3,
            Sendercity: this.Sendercity,
            Receivercity: this.Receivercity,
            Senderzipcode: this.Senderzipcode,
            Receiverzipcode: this.Receiverzipcode,
            bookingPickupdate: this.bookingPickupdate,
            bookingcontentDescription: this.bookingcontentDescription,
          },
        };

        try {
          const response = await axios.post(
            `https://xportal.skyrouteexpress.com/api/getQuoteMail2`,
            $getEmail,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          setTimeout(() => {
            // this.step5 = false;
            this.loader4 = false;
            this.step6 = true;
          }, 3000);
          this.bookingRefId = response.data.booking_reference_id;
          console.log(response, "responseresponse333$getEmail");
        } catch (e) {
          console.log(e, "iioioioi");
        }

        console.log($getEmail, "$getEmail ");
      }
    },
  },
  created() {

this.endpoint=localStorage.getItem("endpoint")

    this.shingConvertData();
    this.quoteId = Math.ceil(Math.random() * 1000000);
    console.log("Math.ceil(Math.random() * 1000000)", this.quoteId);
  },
  mounted() {
    country1.forEach((v) => {
      let obj = {
        name: `${v.dial_code} ${v.name}`,
        code: v.dial_code,
      };
      this.countrycode.push(obj);
    });
  },
};
</script>

<!-- <script setup>


// definePage({ meta: { layout: 'blank' } })
// definePage({
//   meta: {
//     layout: 'blank',
//     unauthenticatedOnly: true,
//   },
// })

export default {
 
  

}
</script> -->

<style scoped>
.pageContainer {
  /* max-width: 900px; */
  /* overflow: auto; */
  display: flex;
  padding-top: 35px;
  /* align-items: center; */
  justify-content: center;
}

.shipperDetail .v-col-md-4 {
  padding: 0 12px !important;
}

.measureSection .title-sub span {
  color: red;
  position: relative;
  top: -3;
}

/* .overallformcard {
  margin-block: 6.2rem;
} */

.formelements {
  inline-size: 65%;
}

.removeBtn {
  margin-block-start: 23px;
}

.measurementSymbol {
  padding-block-start: 24px;
}

.v-autocomplete__selection-text,
.v-select__selection-text {
  padding-block: 10px;
  padding-inline: 0;
}

.v-autocomplete--single.v-text-field input {
  inset-block-start: 24px;
}

.formelements .v-label {
  font-size: 12px !important;
  font-weight: 1000 !important;
}

.v-table {
  box-shadow: 0 2px 6px rgba(var(--v-shadow-key-umbra-color), 0.14),
    0 0 transparent, 0 0 transparent;
  padding-block: 15px;
  padding-inline: 5px;
}

.v-table th {
  line-height: 1;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  margin: 0;
  appearance: none;
}

/* Firefox */
input[type="number"] {
  appearance: textfield;
}

/* .overlay {
  position: fixed;
  z-index: 999;
  display: flex;
  overflow: hidden !important;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 85%);
  block-size: 100%;
  inline-size: 100%;
  inset-block-start: 0;
  inset-inline-start: 0;

}

.overlay-content {
  border-radius: 8px;
  background-color: white;
  inline-size: 35%;
  margin-block-start: 15px !important;
  padding-block: 10px 15px;
  padding-inline: 10px;
}

.overlay-content-booking {
  padding: 20px;
  border-radius: 8px;
  background-color: white;
  inline-size: 85%;
  margin-block-start: 15px !important;
} */

.popupOr {
  text-align: center;
}

.popupform {
  padding: 20px !important;
  border-radius: 15px;
  inline-size: 80%;
  margin-block-start: 50px;
}

.popupdetailsdispCard {
  padding: 20px !important;
  inline-size: 65%;
  /* margin-block: 40px 40px; */
}

.fromandto .v-field__input {
  block-size: 60px;
}

.radioMargins {
  margin-block: -20px -20px !important;
}

.dropdowdata {
  position: absolute;
  z-index: 99;
  padding: 15 !important;
  border-radius: 8px;
  margin: 0;
  background-color: white;
  block-size: 250px;
  box-shadow: inset 0 0 2px black;
  inline-size: 25%;
  list-style: none;
  margin-block-start: 7px;
  overflow-y: scroll;
  scrollbar-width: none;
  cursor: pointer;
  width: auto !important;
}

.dropdowdatali {
  padding: 10px;
  cursor: pointer;
}

.dropdowdatali:hover {
  background-color: #f0f0f0;
}

.popupLabel::after {
  color: #ed1c24;
  content: "*";
  font-size: 17px;
}

.overlayCloseBtn {
  position: absolute;
  background-color: #22224d !important;
  margin-block-start: -40px;
  color: white !important;
}

.booknowBtn {
  padding-block: 30px !important;
}

.finalAlertbox {
  padding: 35px;
  background-color: #22224d !important;
  border-inline-start: 5px solid #ed1c24 !important;
  color: white !important;
  inline-size: 100%;
}

.tabler-map-pins {
  font-size: 27px !important;
}
.title-sub {
  font-size: 15px;
  font-weight: 500;
}
.in-design {
  border: 1px solid;
  width: 138px;
  height: 39px;
  border-radius: 5px;
  font-size: 15px;
  padding: 0px 9px;
  margin-top: 3px;
}
>>> .login-form1 .v-field {
  height: 42px !important;
}
>>> .login-form1 .v-field__prepend-inner {
  height: 42px !important;
}
>>> .login-form1 .v-field__field {
  height: 42px !important;
}
>>> .login-form1 .v-field__input {
  padding-top: 0 !important;
}

.label-title {
  font-size: 14px;
  font-weight: 500;
  color: #545353;
  margin-bottom: 3px;
  font-weight: 500;
  line-height: 1.25rem;
  font-family: "Public Sans", sans-serif, -apple-system, blinkmacsystemfont,
    "Segoe UI", roboto, "Helvetica Neue", arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol" !important;
  text-transform: none !important;
}
.label-head {
  font-size: 19px;
  font-weight: 600;
  color: #2f2b3de0;
  font-family: "Public Sans", sans-serif, -apple-system, blinkmacsystemfont,
    "Segoe UI", roboto, "Helvetica Neue", arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol" !important;
}
.label-sub {
  font-size: 15px;
  font-weight: 500;
  font-family: "Public Sans", sans-serif, -apple-system, blinkmacsystemfont,
    "Segoe UI", roboto, "Helvetica Neue", arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol" !important;
}
.but-color {
  background-color: #1f1f45 !important;
  color: white !important;
}
>>> .text-area .v-field__field {
  height: 50px !important;
}
.ship-title {
  font-size: 14px;
  font-weight: 700;
}
.ship-subtitle {
  font-weight: 500;
  font-size: 14px;
  margin-left: 4px;
}
.ship {
  /* border-bottom: 1px solid lightgray; */
  margin-bottom: 3px;
}

/* ----form start------ */
@media only screen and (max-width: 480px) {
  .measureBox {
    width: 100% !important;
  }
  .btnBox {
    width: 50% !important;
  }
  .unitBox {
    width: 33.33% !important;
    flex-direction: column;
    display: flex;
    margin-top: 2px;
  }
  .unitBox2 {
    width: 33.33% !important;
    flex-direction: column;
    display: flex;
    margin-top: 2px;
  }
  .unitBox3 {
    width: 50% !important;
    flex-direction: column;
    display: flex;
    margin-top: 10px;
  }
  .unitBox4 {
    width: 50% !important;
  }
  .unitBox1 {
    display: none;
  }
}
@media only screen and (min-width: 480px) {
  .unitBox2 {
    display: none;
  }
}

.input-form {
  border: 1px solid #9b9898;
  max-width: 100%;
  height: 30px;
  border-radius: 4px;
  padding: 5px;
  font-size: 12px;
  font-weight: 500;
  position: relative;
  top: -1px;
}
>>> .login-form .v-field {
  height: 30px !important;
  padding: 0 !important;
}

>>> .login-form .v-input__details {
  padding: 0 !important;
  min-height: 0px;
}

>>> .v-messages {
  font-size: 10px;
  min-height: 5px;
}
>>> .login-form .v-field__prepend-inner {
  height: 30px !important;
}
>>> .login-form .v-field__append-inner {
  height: 30px !important;
  padding: 0 !important;
}

>>> .login-form .v-field__input {
  align-items: baseline;
  padding-top: 0 !important;
  height: 30px !important;
  top: 2px !important;
}

>>> .datePick .v-field__input {
  height: -moz-available !important;
  -moz-transform: translateY(-16%) !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #a5a4a4 !important;
}

>>> .itemType .v-field__input {
  top: 3px !important;
}
>>> .dp__pointer {
  cursor: pointer;
  height: 30px;
}
.v-label {
  font-size: 13px !important;
  font-weight: 700 !important;
  color: black !important;
}
>>> .login-form .v-selection-control--inline .v-label {
  width: auto;
  font-size: 12px;
  font-weight: 650;
  margin-left: 4px;
  color: black;
}
:deep(.fromandto .v-input__details){
  display:none !important;
}
:deep(.fromandto .v-input .v-autocomplete__selection input){
  top:10px;
  border:none !important;
}
</style>
